import Swiper, { Scrollbar, A11y, Keyboard } from 'swiper';

// Styles
import './_related-forks.scss';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

const CAROUSEL_SELECTOR = '.carousel--related-forks';
const CAROUSEL_CLASS = 'carousel--related-forks';
const CAROUSEL_SECTION_SELECTOR = '.related-forks';
const CAROUSEL_SCROLLBAR_SELECTOR = '.swiper-scrollbar';


document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {

        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

        // Generate unique btn classes for scroll bar
        element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-scrollbar-${index}`);

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [ Scrollbar, A11y, Keyboard ],
            slidesPerView: 1.1,
            spaceBetween: 40,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 2,
                    spaceBetween: 40
                }
            },
            scrollbar: {
                el: `.${CAROUSEL_CLASS}-scrollbar-${index}`,
                draggable: true
            }
        });

        swiper.slides.forEach(function(slide, index) {
            const slideLink = slide.querySelector('a');
            slideLink?.addEventListener('focus', function() {
                swiper.slideTo(index);
            });
        });
    });
});
